import DetailPage from "../components/DetailPage";
import { detailPages } from "../data/detailPages";

export default function EdgeOpenConnectivity() {
  return <DetailPage data={detailPages["edge-open-connectivity"]} />;
}
